import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi'; // Ícones para abrir/fechar o menu

import { useMediaQuery } from '@mui/material';

function Sidebar({ onLogout }) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false); // Controle de visibilidade do menu

    const handleLogout = () => {
        localStorage.removeItem('isAuthenticated');
        onLogout();
        navigate('/');
    };

    return (
        <div className="relative z-40">
            {/* Botão de menu (visível apenas em mobile) */}
            <button
                className="xl:hidden p-3 m-4 rounded-xl text-white bg-white/10 backdrop-blur-md border border-white/10 fixed top-0 left-0 z-50 hover:bg-white/20 transition-all"
                onClick={() => setIsOpen(!isOpen)}
            >
                {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>

            {/* Backdrop para mobile */}
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 xl:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div
                className={`fixed top-0 left-0 h-screen w-64 text-white z-40 transition-transform transform ${
                    isOpen ? 'translate-x-0' : '-translate-x-full'
                } xl:translate-x-0 xl:sticky bg-white/5 backdrop-blur-xl border-r border-white/10 shadow-2xl flex flex-col`}
            >
                <div className="p-6 flex flex-col justify-between h-full">
                    {/* Título */}
                    <div className="mb-10 mt-4 xl:mt-0 px-2 text-center">
                        <h3 className="text-3xl tracking-wider font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400" style={{ fontFamily: "'Libre Baskerville', serif" }}>
                            Vexor Finance
                        </h3>
                    </div>

                    {/* Navegação */}
                    <nav className="flex flex-col justify-center gap-3 flex-1 overflow-y-auto pr-2">
                        <Link
                            to="/dashboard"
                            className="py-3 px-4 rounded-xl hover:bg-white/10 transition-all text-lg font-medium flex items-center gap-3 border border-transparent hover:border-white/5"
                            onClick={() => setIsOpen(false)}
                        >
                            Dashboard
                        </Link>
                        <Link
                            to="/projects"
                            className="py-3 px-4 rounded-xl hover:bg-white/10 transition-all text-lg font-medium flex items-center gap-3 border border-transparent hover:border-white/5"
                            onClick={() => setIsOpen(false)}
                        >
                            Projetos
                        </Link>
                        <Link
                            to="/clients"
                            className="py-3 px-4 rounded-xl hover:bg-white/10 transition-all text-lg font-medium flex items-center gap-3 border border-transparent hover:border-white/5"
                            onClick={() => setIsOpen(false)}
                        >
                            Clientes
                        </Link>
                        <Link
                            to="/products"
                            className="py-3 px-4 rounded-xl hover:bg-white/10 transition-all text-lg font-medium flex items-center gap-3 border border-transparent hover:border-white/5"
                            onClick={() => setIsOpen(false)}
                        >
                            Estoque
                        </Link>
                        <Link
                            to="/generate-legal"
                            className="py-3 px-4 rounded-xl hover:bg-white/10 transition-all text-lg font-medium flex items-center gap-3 border border-transparent hover:border-white/5"
                            onClick={() => setIsOpen(false)}
                        >
                            Jurídico
                        </Link>
                        <Link
                            to="/generate-quote"
                            className="py-3 px-4 rounded-xl hover:bg-white/10 transition-all text-lg font-medium flex items-center gap-3 border border-transparent hover:border-white/5"
                            onClick={() => setIsOpen(false)}
                        >
                            Orçamento
                        </Link>
                    </nav>

                    {/* Botão Logout */}
                    <button
                        onClick={handleLogout}
                        className="mt-6 py-3 px-4 rounded-xl bg-red-500/20 text-red-300 hover:bg-red-500/40 hover:text-white border border-red-500/30 transition-all text-lg font-medium"
                    >
                        Sair da Conta
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
